import { useState } from 'react';
import { ConfirmationDialog } from '../../../components/Common/ConfirmationDialog';
import { ClientIdType } from '../../PricingSheets/Dialogs/CustomerSelector';
import CustomerSearchSelector from '../../../components/Steps/Components/Selectors/CustomerSearchSelector';
import { Alert, Box, Typography } from '@mui/material';

type OfferApprovalDialogProps<T extends Record<string, string>> = {
  loading?: boolean;
  onClose: () => void;
  onConfirm: (customerId: string, clientName: string) => void;
  open: boolean;
  title: string;
  customerName?: string;
};

export const OfferApprovalDialog = <
  T extends Record<string, string>,
>({
  loading = false,
  onClose = () => null,
  onConfirm = () => null,
  open,
  title,
  customerName,
}: OfferApprovalDialogProps<T>) => {
  const [clientId, setClientId] = useState<any>();
  const [clientName, setClientName] = useState<any>();

  return (
    <ConfirmationDialog
      open={open}
      loading={loading}
      onCancel={onClose}
      onConfirm={() => onConfirm(clientId.value, clientName)}
      title={title}
      confirmButtonLabel={'Vahvista'}
      isConfirmDisabled={!Boolean(clientId)}
    >
      <Alert severity="info">
        Tarjoukselle ei ole asetettu asiakasta tai sille ei ole
        ladattu MIRA:n asiakasnumeroa. Aseta tarjoukselle asiakas haun
        kautta.
      </Alert>
      <Box
        display={'flex'}
        flexDirection={'column'}
        gap={1}
        sx={{ my: 2 }}
      >
        <Typography>{`Tarjouspyynnössä annettu nimi: ${customerName ? customerName : 'Ei asetettu'}`}</Typography>
        <Typography>{`Asiakas: ${clientId ? clientId.label : 'Ei asetettu'}`}</Typography>
      </Box>
      <CustomerSearchSelector
        showCustomerCard={false}
        disableProspects={true}
        customerName={''}
        customerId={''}
        companyId={''}
        onCustomerChange={(clientOption) => {
          if (clientOption) {
            setClientId({
              label: `${clientOption.value}, ${clientOption.id}`,
              value: clientOption.id ?? '',
            });
            setClientName(clientOption.value);
          }
        }}
      />
    </ConfirmationDialog>
  );
};
